import "./setDynamicChunkPath";
// eslint-disable-next-line react/no-deprecated
import { hydrate } from "react-dom";
import loadPolyfills from "./loadPolyfills";
import { APP_SHORT_NAME } from "../../universal/constants";

const bootstrap = async entryPointFactory => {
  await loadPolyfills();

  await import(
    /* webpackPreload: true, webpackChunkName: "errorHandling" */ "../exceptionHandling/index"
  );
  const { default: appContentInitialiser } = await import(
    /* webpackPreload: true, webpackChunkName: "contentInit" */ "./appContentInitialiser"
  );
  await appContentInitialiser();

  const [{ default: App }, { default: EntryPoint }] = await Promise.all([
    import(
      /* webpackPreload: true, webpackChunkName: "entry" */ "../components/containers/common/App"
    ),
    entryPointFactory()
  ]);

  hydrate(
    <App EntryPoint={EntryPoint} />,
    document.getElementById(APP_SHORT_NAME).parentNode
  );
};

export default bootstrap;
